/**
 * Shared configuration for the Orion landing page sections and the global
 * OrionSidenav. Both the landing-page card grid and the sidebar render
 * controls grouped by these sections, so keeping the source of truth here
 * avoids drift when sections are renamed, reordered, or have new entries
 * added.
 */
export const SECTION_CONFIG = [
  { icon: 'shield' as const, headerText: 'GRC Control Automation', controlType: 'FIXED_ASSETS' },
  { icon: 'chartBar' as const, headerText: 'Reporting Analytics', controlType: 'Reports' },
] as const;

export type SectionConfigItem = (typeof SECTION_CONFIG)[number];
